import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import ButtonTinyWithSpinnerUI from '../../../widgets/action/ButtonTinyWithSpinnerUI'
import BPFPaymentModalSF from './BPFPaymentModalSF'
import LegalFeeModalSF from './LegalFeeModalSF'

const BillFeeUI = ({ loan, context, onRefreshClick,
    billProcessingFeeSubmitted, onBillProcessingFeeSubmitClick, onBillProcessingFeeCancelClick,
    legalFeeSubmitted, onLegalFeeSubmitClick, onLegalFeeCancelClick
}) =>
    <CardUI className='g_m_bottom_100' title='Other fees'>

        {
            context.permissions.includes('su_finance') &&
            <>
                <ButtonTinyWithSpinnerUI label='Pay bill processing fee' alignLeft={true}
                    onClick={onBillProcessingFeeSubmitClick} busy={billProcessingFeeSubmitted} rowId={loan.loanId} />

                <ButtonTinyWithSpinnerUI label='Pay legal fee' alignLeft={true}
                    onClick={onLegalFeeSubmitClick} busy={legalFeeSubmitted} rowId={loan.loanId} />
            </>
        }

        <BPFPaymentModalSF
            context={context} loan={loan}
            onRefreshClick={onRefreshClick}
            onCancelClick={onBillProcessingFeeCancelClick}
            updateMode={billProcessingFeeSubmitted}
        />

        <LegalFeeModalSF
            context={context} loan={loan}
            onRefreshClick={onRefreshClick}
            onCancelClick={onLegalFeeCancelClick}
            updateMode={legalFeeSubmitted}
        />
    </CardUI>

export default BillFeeUI
